/*
 * @Descripttion:
 * @version:
 * @Author: gaochen
 * @Date: 2021-09-08 15:39:06
 * @LastEditors: gaochen
 * @LastEditTime: 2021-09-16 10:24:02
 */
const workbenchRouter = [
  {
    path: 'board-workbench',
    name: 'BoardWorkbench',
    component: () => import('@/views/wxapp/bulletin-board/workbench'),
    meta: {
      title: '工作台'
    },
    children: [
      {
        path: 'work-order',
        name: 'WorkOrder',
        component: () => import('@/views/wxapp/bulletin-board/workbench/workOrder'),
        meta: {
          title: '工作台'
        }
      },
      {
        path: 'workbench-abnormal',
        name: 'WorkbenchAbnormal',
        component: () => import('@/views/wxapp/bulletin-board/workbench/abnormal'),
        meta: {
          title: '经营利润异常单'
        }
      },
      {
        path: 'management-order-index',
        name: 'ManagementOrderIndex',
        component: () => import('@/views/wxapp/bulletin-board/workbench/managementOrder'),
        meta: {
          title: ''
        }
      }

    ]
  }
]
export default workbenchRouter
